// import { ShieldCheck, Lock, Upload, Zap } from 'lucide-react';

// const features = [
//   {
//     icon: ShieldCheck,
//     title: 'Verified Sellers',
//     description: 'All sellers undergo strict verification to ensure authenticity and trust.',
//   },
//   {
//     icon: Lock,
//     title: 'Secure Platform',
//     description: 'Your data is protected with advanced security measures and encryption.',
//   },
//   {
//     icon: Upload,
//     title: 'Easy Listing',
//     description: 'List your vehicle in minutes with our simple step-by-step process.',
//   },
//   {
//     icon: Zap,
//     title: 'Fast Search',
//     description: 'Find your perfect vehicle quickly with our advanced search filters.',
//   },
// ];

// export function WhyChoose() {
//   return (
//     <section className="py-16 bg-gradient-to-br from-[#2D323A] via-[#1E1E26] to-[#121212] text-white relative overflow-hidden">
//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-5">
//         <div className="absolute inset-0" style={{
//           backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
//           backgroundSize: '40px 40px'
//         }} />
//       </div>

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl sm:text-4xl mb-4">
//             Why Choose <span className="text-[#1E6DFF]">MORROCARS</span>
//           </h2>
//           <p className="text-lg text-[#BFC2C7] max-w-2xl mx-auto">
//             Morocco's most trusted automotive marketplace connecting buyers and sellers
//           </p>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {features.map((feature, index) => {
//             const Icon = feature.icon;
//             return (
//               <div
//                 key={feature.title}
//                 className="group relative"
//               >
//                 {/* Card */}
//                 <div className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#1E6DFF]/50 transition-all duration-300 hover:bg-white/10">
//                   {/* Icon */}
//                   <div className="w-16 h-16 bg-[#1E6DFF]/20 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#1E6DFF]/30 transition-all">
//                     <Icon className="w-8 h-8 text-[#1E6DFF]" />
//                   </div>

//                   {/* Content */}
//                   <h3 className="text-xl mb-3">{feature.title}</h3>
//                   <p className="text-[#BFC2C7] leading-relaxed">
//                     {feature.description}
//                   </p>

//                   {/* Number Badge */}
//                   <div className="absolute top-6 right-6 w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-[#BFC2C7] text-sm">
//                     {String(index + 1).padStart(2, '0')}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Decorative Gradient */}
//       <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#1E6DFF] rounded-full filter blur-3xl opacity-10" />
//     </section>
//   );
// }
// src/components/WhyChoose.jsx
import { ShieldCheck, Lock, Upload, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCms } from '../hooks/useCms';

export function WhyChoose() {
  const { t } = useTranslation('home');
  const { get } = useCms('home');

  const features = [
    {
      icon: ShieldCheck,
      title: get('why_choose.benefit1', t('why_choose.features.verified.title')),
      description: get('why_choose.benefit1Description', t('why_choose.features.verified.description')),
    },
    {
      icon: Lock,
      title: get('why_choose.benefit2', t('why_choose.features.secure.title')),
      description: get('why_choose.benefit2Description', t('why_choose.features.secure.description')),
    },
    {
      icon: Upload,
      title: get('why_choose.benefit3', t('why_choose.features.easy.title')),
      description: get('why_choose.benefit3Description', t('why_choose.features.easy.description')),
    },
    {
      icon: Zap,
      title: get('why_choose.benefit4', t('why_choose.features.fast.title')),
      description: get('why_choose.benefit4Description', t('why_choose.features.fast.description')),
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#2D323A] via-[#1E1E26] to-[#121212] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl mb-4">
            {get('why_choose.whyTitle', t('why_choose.title'))} <span className="text-[#1E6DFF]">{get('why_choose.whyHighlight', t('why_choose.brand'))}</span>
          </h2>
          <p className="text-lg text-[#BFC2C7] max-w-2xl mx-auto">
            {get('why_choose.whyDescription', t('why_choose.subtitle'))}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={feature.title} className="group relative">
                {/* Card */}
                <div className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#1E6DFF]/50 transition-all duration-300 hover:bg-white/10">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-[#1E6DFF]/20 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#1E6DFF]/30 transition-all">
                    <Icon className="w-8 h-8 text-[#1E6DFF]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl mb-3">{feature.title}</h3>
                  <p className="text-[#BFC2C7] leading-relaxed">
                    {feature.description}
                  </p>

                  {/* Number Badge */}
                  <div className="absolute top-6 right-6 w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-[#BFC2C7] text-sm">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Decorative Gradient */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#1E6DFF] rounded-full filter blur-3xl opacity-10" />
    </section>
  );
}
